import React from "react";
import "./styles.less";
import { Header } from "../../components/Header";
import { CommonBanner } from "../../blocks/common-banner";
import { BlockTry } from "../../blocks/common-blocktry";
import { DatabaseIntro } from "../../blocks/database-intro";
import { useTranslation } from "react-i18next";

import { DatabaseAdvantage } from "../../blocks/database-advantage";
import { DatabaseSolutions } from "../../blocks/database-solutions";
import { DatabaseTable } from "../../blocks/database-table";
import { CommonLinkPage } from "../../blocks/common-link-page";
import { CommonPageLink } from "../../blocks/common-page-link";
import { Footer } from "../../components/Footer";

export const DatabasePage = () => {
  const { t } = useTranslation();
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  return (
    <div className="databese-page">
      <Header mode={"light"} />
      <CommonBanner
        title={t("learn.database.banner.title")}
        subtitle={t("learn.database.banner.subtitle")}
        imgurl="/product-database-banner-new.png"
        docLink="//docs.authing.cn/v2/guides/database-connection/overview.html"
      />
      <DatabaseIntro />
      <DatabaseAdvantage />
      <DatabaseSolutions />
      <DatabaseTable />
      <CommonPageLink pagesLink={pagesLink} />
      <BlockTry />
      <Footer />
    </div>
  );
};
